<template>
    <div
        class="afu-mb-7"
        :class="`afu-cs-${getTitleClass(attr.title)}`"
    >
        <ValidationProvider
            ref="provider"
            v-slot="{ validate, errors }"
            :name="attr.title"
            :rules="getRuleStr"
        >
            <C1FormGroup>
                <C1Label class="af-label afu-text-secondary-dark afu-block afu-mb-2 af-text--7xl afu-font-semibold">
                    <span v-html="attr.title"> </span>
                </C1Label>
                <div v-if="attr.type === 'text'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="text"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'date'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        :max="attr.rules && getDateAttributeRule(attr.rules.max)"
                        :min="attr.rules && getDateAttributeRule(attr.rules.min)"
                        type="date"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'datetime'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="datetime-local"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'week'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="week"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'month'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="month"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'time'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="time"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'textarea'">
                    <C1FormTextarea
                        :id="attr.title"
                        v-model="attr.value"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        name="attr.title"
                        class="afu-mb-0"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                        :max-length=getMaxLength(attr)
                    />
                    <div
                        v-if="attr.rules.max > 0" 
                        class="textarea-char-count afu-float-right"
                        :class="(attr.value && attr.value.length >= attr.rules.max) ? 'afu-font-bold': ''"
                    >
                        <span v-if="attr.value" class="current">{{ attr.value.length }}</span>
                        <span v-else class="current">0</span>
                        <span class="maximum">/{{ attr.rules.max }}</span>
                    </div>
                </div>
                <div v-if="attr.type === 'number'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="number"
                        :value="attr.value"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'email'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="text"
                        :disabled="userLoggedIn"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                    <small v-if="errors[0] == 'email_taken' && !userLoggedIn" v-html="$t('custom_form.email_taken', {value: getRedirectUrl()})" class="af-help-text afu-block afu-mt-1 afu-text-danger-400"> 
                    </small>
                    <small v-else class="af-help-text afu-block afu-mt-1 afu-text-danger-400 text-sm">
                        {{ errors[0] }}
                    </small>
                </div>
                <div v-if="attr.type === 'password'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="password"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'phone'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="text"
                        :value="attr.value"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'url'">
                    <C1FormInput
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        type="text"
                        :value="attr.value"
                        @blur="attributeChanged(attr)"
                        @keyup.enter="attributeChanged(attr)"
                    />
                </div>
                <div v-if="attr.type === 'select'">
                    <div v-if="attr.misc && attr.misc.typeahead">
                        <C1Typeahead
                            v-model="attr.model"
                            :is-invalid="!!errors[0]"
                            :invalid-feedback="errors[0]"
                            :options="attr.options"
                            placeholder="Please Type"
                            :label-key="attr.misc.label_field"
                            :value-key="attr.misc.value_field"
                            @search="searchAttributeOptions($event, attr)"
                            @hit="changeSelectOption($event, attr)"
                        />
                    </div>
                    <div v-else>
                        <C1Select
                            :id="attr.title"
                            v-model="attr.value"
                            placeholder="Please Select"
                            :options="attr.options"
                            :is-invalid="!!errors[0]"
                            :invalid-feedback="errors[0]"
                            @input="attributeChanged(attr)"
                        />
                    </div>
                </div>
                <div v-if="attr.type === 'multiselect'">
                    <div v-if="attr.misc && attr.misc.typeahead">
                        <C1Typeahead
                            :options="attr.options"
                            placeholder="Please Type"
                            :label-key="attr.misc.label_field"
                            :value-key="attr.misc.value_field"
                            clean-after-select
                            @search="searchAttributeOptions($event, attr)"
                            @hit="addMultiselectOption($event, attr)"
                        />
                        <C1HelpText
                            v-if="attr.value.length == 0 && errors[0]"
                            variant="danger"
                        >
                            {{ errors[0] }}
                        </C1HelpText>
                    </div>
                    <div v-else>
                        <C1Multiselect
                            :is-invalid="!!errors[0]"
                            :invalid-feedback="errors[0]"
                            v-model="attr.value"
                            placeholder="Please Select"
                            :options="attr.options"
                            @hit="attributeChanged(attr)"
                        />
                    </div>

                    <div
                        v-if="attr.value && attr.value.length"
                        class="afu-mt-5"
                    >
                        <C1Tag
                            v-for="attribute in attr.value"
                            :key="`${attribute.id}`"
                            removable
                            @remove="detachMultiselectOption(attr.value, attribute)"
                        >
                            {{ attribute.label }}
                        </C1Tag>
                    </div>
                </div>
                <div v-if="attr.type === 'checkbox'">
                    <C1CheckBox
                        :id="attr.title"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        v-model="attr.value"
                        :name="attr.title"
                        :value="attr.value"
                        :content="attr.description"
                    />
                </div>
                <div v-if="attr.type === 'file'">
                    <div
                        class="afu-text-black afu-text-sm afu-mt-2 afu-bg-white afu-text-center afu-border-dashed afu-border-neutral afu-p-5"
                    >
                        <C1Button
                            :id="attr.title"
                            class="file-upload-btn no-border afu-border-none"
                            @click.stop.prevent="openFileModal(attr.id)"
                        >
                            <div>
                                <span class="afu-text-secondary-dark afu-mb-8 upload-label">{{$t('label.upload_label') }}</span> <br>
                                <span class="afu-text-base afu-text-neutral-dark afu-font-normal">({{$t('label.upload_file_size')}})</span>
                            </div>
                        </C1Button>
                        <input
                            :ref="`file-${attr.id}`"
                            :name="attr.title"
                            type="file"
                            @change="uploadingFile($event, attr, validate)"
                            style="display: none;"
                        >
                    </div>
                    <div
                        v-if="attr.value"
                        class="afu-mt-2 afu-p-1 afu-flex afu-flex-col md:afu-flex-row md:afu-items-center afu-justify-between"
                    >
                        <div>
                            <div class="afu-text-sm afu-leading-6xl afu-font-semibold afu-text-neutral-dark afu-mb-5">
                                {{$t('label.uploaded_document').toUpperCase() }}
                            </div>
                            <div class="uploaded-file-info afu-inline-flex">
                                <div>
                                    <FontAwesomeIcon
                                        :icon="['far', 'dot-circle']"
                                        class="afu-mr-2 afu-w-3 afu-text-primary afu-mt-5"
                                    />
                                </div>
                                <div>
                                    <div class="afu-text-mds afu-font-semibold afu-text-black afu-mb-2">
                                        {{ attr.value.name }}
                                    </div>
                                    <div class="afu-text-neutral-dark afu-font-normal afu-mb-1">{{getFileSize(attr.value.size)}} {{attr.value.extension.toUpperCase()}}</div>
                                    <div class="afu-text-sm afu-font-semibold afu-text-neutral-dark">
                                        {{ $t('label.uploaded') }} 
                                        <span v-if="uploadedNow">
                                            {{ $t('label.uploaded_now') }}
                                        </span>
                                        <span v-else>
                                            {{ getFormattedDate(attr.value.lastModified) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="afu-mt-3 afu-ml-4">
                                <C1Button
                                    variant="neutral"
                                    class="afu-ml-2"
                                    @click.stop.prevent="openFileModal(attr.id)"
                                >
                                    {{ $t('label.upload_new') }}
                                </C1Button>
                                <input
                                    :ref="`file-${attr.id}`"
                                    :name="attr.title"
                                    type="file"
                                    @change="uploadingFile($event, attr, validate)"
                                    style="display: none;"
                                >
                            </div>
                        </div>
                    </div>
                    <C1HelpText
                        v-if="errors[0]"
                        variant="danger"
                    >
                        {{ errors[0] }}
                    </C1HelpText>
                </div>
                <div v-if="attr.type === 'image'">
                    <div
                        v-if="!attr.value"
                        class="afu-text-black afu-text-sm afu-mt-2 afu-bg-white"
                    >
                        <C1Button
                            :id="attr.title"
                            variant="primary"
                            @click.stop.prevent="openFileModal(attr.id)"
                        >
                            <FontAwesomeIcon
                                :icon="['far', 'plus']"
                                class="afu-mr-2"
                            />
                            Add an image
                        </C1Button>
                        <input
                            :ref="`file-${attr.id}`"
                            :name="attr.title"
                            type="file"
                            @change="uploadingImage($event, attr, validate)"
                            style="display: none;"
                        >
                    </div>
                    <div
                        v-else
                        class="afu-border-b afu-border-solid afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-neutral afu-mt-2 afu-p-1 afu-flex afu-flex-col md:afu-flex-row md:afu-items-center afu-justify-start"
                    >
                        <div class="afu-mr-10">
                            <PreviewImage
                                size="md"
                                :image="attr.image"
                                class="afu-my-5"
                            />
                        </div>

                        <div class="afu-mt-3 md:afu-mt-0">
                            <C1Button
                                variant="neutral"
                                class="afu-ml-2"
                                @click="removeFile(attr, validate)"
                            >
                                <FontAwesomeIcon
                                    :icon="['fal', 'trash-alt']"
                                    class="afu-mr-2"
                                    fixed-width
                                />

                                {{ $t('label.remove') }}
                            </C1Button>
                        </div>
                    </div>
                    <C1HelpText
                        v-if="errors[0]"
                        variant="danger"
                    >
                        {{ errors[0] }}
                    </C1HelpText>
                </div>
            </C1FormGroup>
        </ValidationProvider>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Cookie from '@/services/cookie';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Label from '@/components/C1Components/C1Label';
    import C1Select from '@/components/C1Components/C1Select';
    import C1CheckBox from '@/components/C1Components/C1CheckBox';
    import C1Multiselect from '@/components/C1Components/C1Multiselect';
    import C1Tag from '@/components/C1Components/C1Tag';
    import C1HelpText from '@/components/C1Components/C1HelpText';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';
    import C1FormTextarea from '@/components/C1Components/C1FormTextarea';
    import C1Typeahead from '@/components/C1Components/C1Typeahead';
    import PreviewImage from '@/components/Seeker/PreviewImage';
    import moment from 'moment/src/moment';
    import { ValidationProvider } from 'vee-validate';

    export default {
        name: 'CustomAttributeInput',

        components: {
            C1Typeahead,
            C1HelpText,
            C1Select,
            C1CheckBox,
            C1Multiselect,
            C1Tag,
            C1Label,
            C1Button,
            C1FormInput,
            C1FormGroup,
            C1FormTextarea,
            PreviewImage,
            ValidationProvider,
        },

        props: {
            attr: {
                type: Object,
                default: () => ({
                    title: '',
                    value: null,
                    options: [],
                    misc: {},
                }),
            },
            redirectUrl: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                customAttributes: [],
                attributeOptions: [],
                selectedFile: null,
                value: '',
                uploadedNow: false,
            };
        },

        computed: {
            getRuleStr() {
                const rules = [];
                if (this.attr.is_mandatory) {
                    rules.push('required');

                    if (this.attr.type === 'multiselect' && this.attr.misc?.typeahead && this.attr.value.length > 0) {
                        const index = rules.indexOf('required');            
                        if (index >= 0) {
                            rules.splice(index, 1);
                        }
                    }
                    if (this.attr.type === 'file' && this.attr.value) {
                        const index = rules.indexOf('required');            
                        if (index >= 0) {
                            rules.splice(index, 1);
                        }
                    }
                }
                switch (this.attr.type) {
                    case 'text':
                        if (this.attr.rules?.max) {
                            rules.push(`max:${this.attr.rules.max}`);
                        }
                        if (this.attr.rules?.min) {
                            rules.push(`min:${this.attr.rules.min}`);
                        }
                        break;
                    case 'number':
                        rules.push('numeric');
                        if (this.attr.rules?.max) {
                            rules.push(`max_value:${this.attr.rules.max}`);
                        }
                        if (this.attr.rules?.min) {
                            rules.push(`min_value:${this.attr.rules.min}`);
                        }
                        break;
                    case 'email':
                        rules.push('email');
                        if (this.attr.category == 'platform' && !this.userLoggedIn) {
                            rules.push('email_exists');
                        }
                        break;
                    case 'url':
                        rules.push('url');
                        break;
                    case 'phone':
                        rules.push('phone_number');
                        break;
                }
                return rules.join('|');
            },
            userLoggedIn() {
                const token = Cookie.getToken();
                return (token) ? true : false;
            },
        },

        methods: {
            ...mapActions('me', {
                $_syncAttributes: 'getCustomAttributes',
                $_getAttributes: 'getAttributes',
                $_getCustomAttributes: 'getCustomAttributes',
                $_updateCustomAttributes: 'updateCustomAttributes',
                $_storeCustomFieldDocument: 'storeCustomFieldDocument',
                $_downloadCustomFieldDocument: 'downloadCustomFieldDocument',
                $_removeCustomFieldDocument: 'removeCustomFieldDocument',
            }),

            ...mapActions('user', {
                $_checkEmail: 'checkEmail',
            }),

            attributeChanged(attr) {
                this.$emit('changed', attr);
            },

            searchAttributeOptions(keyword, attr) {
                if (attr.misc.url) {
                    this.$axios
                        .$get(`${attr.misc.url}`, {
                            params: {
                                [attr.misc.query_param]: keyword,
                            },
                        })
                        .then(response => {
                            if (response.data) {
                                attr.options = response.data;
                            }
                        });
                }
            },

            addMultiselectOption(attributeOption, attr) {
                const option = {
                    id: attributeOption[attr.misc.value_field],
                    label: attributeOption[attr.misc.label_field],
                };
                if (attr.value) {
                    if (!attr.value.find(ele => ele.id === option.id)) {
                        attr.value.push(option);
                    }
                } else {
                    this.$set(attr, 'value', [option]);
                }
            },

            changeSelectOption(attributeOption, attr) {
                let option = null;
                if (attributeOption) {
                    option = {
                        id: attributeOption[attr.misc.value_field],
                        label: attributeOption[attr.misc.label_field],
                    };
                }

                this.$set(attr, 'value', option);
            },

            detachMultiselectOption(selectedOptions, attributeOption) {
                const index = selectedOptions.findIndex(
                    o => o.id === attributeOption.id,
                );
                selectedOptions.splice(index, 1);
                this.attributeChanged(selectedOptions);
            },

            getDateAttributeRule(value) {
                switch (value) {
                    case 'today':
                        value = moment().format('YYYY-MM-DD');
                        break;
                    case 'yesterday':
                        value = moment()
                            .subtract(1, 'days')
                            .format('YYYY-MM-DD');
                        break;
                    case 'tomorrow':
                        value = moment()
                            .subtract(-1, 'days')
                            .format('YYYY-MM-DD');
                        break;
                }

                return value;
            },

            openFileModal(id) {
                const ref = `file-${id}`;
                this.$refs[ref].click();
            },

            async uploadingFile(e, attr, validate) {
                const file = e.target.files[0];
                if (file) {
                    validate(e);
                    file.extension = file.name.split('.').pop();
                    this.$set(attr, 'value', file); 
                    this.uploadedNow = true;
                }
            },

            async uploadingImage(e, attr, validate) {
                const file = e.target.files[0];
                if (file) {
                    validate(e);
                    this.$set(attr, 'value', file);
                    attr.image = { src: URL.createObjectURL(file) };
                }
            },

            // attr.image

            async removeFile(attr, validate) {
                attr.value = null;
                attr.image = null;
                validate(null);
            },  

            getFileSize(x) {
                const units = ['bytes', 'kb', 'mb'];
                let initalSize = 0, converted = parseInt(x, 10) || 0;
                while(converted >= 1024 && ++initalSize){
                    converted = converted/1024;
                }
                return (converted.toFixed(converted < 10 && initalSize > 0 ? 1 : 0) + ' ' + units[initalSize]); 
            },

            getFormattedDate(value) { 
                return moment(value).format('ll');               
            },
            
            getTitleClass(str) {
                return str.toLowerCase().replace(/\s+/g, '-');
            },

            getMaxLength(attr) {
                return attr.rules.max > 0 ? attr.rules.max : '';
            },

            getRedirectUrl() {
                const loginUrl = '/user-login/';
                if (this.redirectUrl) {
                    return `${loginUrl}?redirect=${this.redirectUrl}`;
                } 
                return loginUrl;
            },
        },
    };
</script>

<style>
    .file-upload-btn.no-border {
        border: none;
    }

    .file-upload-btn.no-border:hover {
        background: none;
        color: #ccc;
    }
</style>
